import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { AIAgentTemplateFilter, IAIAgentTemplate } from '../../extViewmodels/sdk/models/AI';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = '/aiagenttemplate/filter';

export const useAIAgentTemplateFilterInfiniteQuery = ({
	filter,
	pageSize = 25,
	enabled = true,
	impersonationContext,
}: {
	filter: AIAgentTemplateFilter;
	pageSize?: number;
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}) => {
	const userSession = useUserSession();
	return useInfiniteQuery({
		enabled,
		queryFn: ({ pageParam }) => {
			return userSession.webServiceHelper.callAsync<Api.IPagedCollection<IAIAgentTemplate>>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					queryParams: { pageSize, pageToken: pageParam },
					urlPath: 'aiagenttemplate/filter',
				}),
				'POST',
				filter
			);
		},
		getNextPageParam: lastPage => lastPage.pageToken,
		queryKey: [BASE_QUERY_KEY, filter, pageSize, impersonationContext],
		initialPageParam: '',
	});
};

export const invalidateAIAgentTemplateFilter = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
};
